module.exports = __webpack_public_path__ + "static/img/why-4.9ee8acf5.png";